import { render } from "./create_organization.vue?vue&type=template&id=1f79d147&scoped=true"
import script from "./create_organization.js?vue&type=script&lang=js"
export * from "./create_organization.js?vue&type=script&lang=js"

import "./create_organization.vue?vue&type=style&index=0&id=1f79d147&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f79d147"]])

export default __exports__